import { format } from 'date-fns'
import locale from 'date-fns/locale/es'
import { CPArticle } from '../Views/Homepage/types'

export const humanDate = (article: CPArticle) => {
  return format(new Date(article.date_created), `dd 'de' MMMM 'de' yyyy`, {
    locale
  })
}
